import React, { useEffect, useState, useRef } from "react"
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { takeExternalAction } from "../../../actions/auth";
import Modal from "../../common/Modal/Modal";
import auth from "../../../reducers/auth";

export function ExternalAction(props) {

    const [isLoading, setIsLoading] = useState(true);
    const externalAction = useSelector(state => state.auth.externalAction);
    const result = externalAction?.success ? "success" : (externalAction?.error ? "error" : "");

    const getSuccessMsg = () => {
        switch(props.match.params.response) {
            case "reject": return "You have rejected the invoice. The vendor will be notified."
            case "approve": return "You have successfully approved this invoice."
            case "paid": return "You have successfully aknowleged payment of this invoice. The vendor will be notified."
            default: return ""
        }
    }

    const externalActionHasRun = useRef(false);
    // when the component mounts, Grab information from URL and send to back-end to respond to email
    useEffect(() => {
        if (!externalActionHasRun.current) {
            if (!externalAction) {
                externalActionHasRun.current = true;
                props.takeExternalAction(props.match.params.uidb64, props.match.params.token, props.match.params.response);
            }
        }
        externalAction && setIsLoading(false);
    }, [externalAction]);


    switch(result) {
    case "success":
        return (
            <Modal >
                {!isLoading &&
                <div className="text-center" >
                    <p className="title2 heavy gap-below-m" >Success</p>
                    <p className="content1 light-black multiline gap-below-l" >{getSuccessMsg()}</p>
                </div>}
            </Modal>
        )
    case "error":
        return (
            <Modal  >
                {!isLoading &&
                    <div className="text-center" >
                    <p className="title2 heavy gap-below-s" >Error</p>
                    <p className="content1 light-black multiline" >{externalAction?.error}</p>
                </div>}
            </Modal>
        )
    case "":
    default:
        return (
            <></>
        )
    }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {takeExternalAction})(ExternalAction);

